import { FC, useState } from 'react';

import { FlexColumn } from '@mopla/ui';
import { AllDevices, Lamp, MyWayFlex, Wallet } from '@mopla/ui/icons';
import { DTicketExist } from '@mopla/ui/icons/DTicketExist';
import pauseDTicketIconSrc from '@mopla/ui/icons/pauseDTicket.svg?url';
import { Carousel } from '@mopla/ui/molecules/Carousel/Carousel';

import { marketingItems } from './constants';
import {
	DTicketMarketingItem,
	IMarketingFlowProps,
} from './DTicketMarketingItem';
import { BlockRoot, CustomStepper } from './MarketingBlock.styles';
import { MyWayMarketingItem } from './MyWayMarketingItem';

const dTicketIcon = (
	<img
		src={pauseDTicketIconSrc}
		alt="Deutschland ticket"
		style={{ width: '100%', height: '100%', objectFit: 'contain' }}
	/>
);

const initialIndex = 1;
const dTicketSlideImageByIndex = [<Wallet />, dTicketIcon, <DTicketExist />];
const myWaySlideImageByIndex = [<Lamp />, <MyWayFlex />, <AllDevices />];

export const MarketingBlock: FC<IMarketingFlowProps> = ({ type }) => {
	const [activeIndex, setActiveIndex] = useState(initialIndex);

	const setIndex = (slideIndex: number) => setActiveIndex(slideIndex);

	const dTicketSlidesList = marketingItems.map((item, index) => (
		<DTicketMarketingItem {...item} image={dTicketSlideImageByIndex[index]} />
	));

	const myWaySlidesList = marketingItems.map((item, index) => (
		<MyWayMarketingItem {...item} image={myWaySlideImageByIndex[index]} />
	));

	return (
		<FlexColumn className="spaceBetween">
			<BlockRoot>
				{type === 'dTicket' ? (
					<Carousel
						slideList={dTicketSlidesList}
						onActiveIndexChange={setIndex}
					/>
				) : (
					<Carousel
						slideList={myWaySlidesList}
						onActiveIndexChange={setIndex}
					/>
				)}
			</BlockRoot>
			<CustomStepper
				variant="dots"
				steps={marketingItems.length}
				position="static"
				activeStep={activeIndex - 1}
				nextButton={null}
				backButton={null}
			/>
		</FlexColumn>
	);
};
